module.exports = new __parcel__URL__("animal-crossing-new-horizons.3636af97.jpg").toString();